/**
 * Trader-owned preferences (`users.prefs` JSONB, 2026-10-19). Set by the trader
 * (`PATCH /api/trader/me/prefs`) or by a manager on the member card; returned
 * on `/api/trader/me`. A preference, never a grant: absent = default.
 */
export interface TraderPrefs {
  /** MrGreenMode narrows optional game market subscriptions until props are
   * opened; account, order, fill and reference-odds delivery stays unchanged. */
  lowBandwidth?: boolean;
}

/** Normalises whatever the relay returned into a prefs object (never throws). */
export function parseTraderPrefs(raw: unknown): TraderPrefs {
  if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const r = raw as Record<string, unknown>;
  const out: TraderPrefs = {};
  if (typeof r.lowBandwidth === 'boolean') out.lowBandwidth = r.lowBandwidth;
  return out;
}
